import { CONTEXT_DOCUMENTS_ROUTE } from '@/lib/constants/contextDocuments'
import { LANGUAGES } from '@/lib/constants/languages'
import { PUBLIC_API } from '@/lib/constants/publicApi'
import { SUPPLIER_QUESTIONNAIRES } from '@/lib/constants/supplierQuestionnaires'
import { USER_ROLES } from '@/lib/constants/users'
import type { IUserRole } from '@/types/user'
import type { IMailProvider } from './providers/mail'

const HOME_PAGE: Record<IUserRole, string> = {
  [USER_ROLES.ADMIN]: '/',
  [USER_ROLES.EDITOR]: '/',
  [USER_ROLES.CONSULTANT]: '/',
  [USER_ROLES.CONSULTANT_ADMIN]: '/',
  [USER_ROLES.VIEWER]: '/employee-center',
  [USER_ROLES.AUDITOR]: '/',
  [USER_ROLES.MDM_EDITOR]: '/mdm/groups',
  [USER_ROLES.SUPPLIER]: '/suppliers/questionnaires',
}
const S = {
  SCHEDULE_CALL_URL: 'https://calendar.app.google/6vGUPzANC5gJae6q8',
  BILLING_URL: 'https://billing.stripe.com/p/login/28o7ux5rJ9swfqo6oo',
  DELAY_TESING_SERVER_ACTIONS: 1000,
  DEFAULT_LANGUAGE: LANGUAGES.ENGLISH,
  EMPLOYEES_BULK_UPLOAD_TEMPLATE_URL:
    'https://docs.google.com/spreadsheets/' + 'd/1Ji6W77fpwP0yaOsY8LqypoK2-TCcIEAOIopU56BtCLU/edit?usp=sharing',
  // Please, if you change this file size limit value,
  // change it in ../next.config.js -> nextConfig.experimental.serverActions.bodySizeLimit as well
  FILE_SIZE_LIMIT_IN_MB: process.env.PRODUCTION ? 4 : 10,
  DEFAULT_ORGANIZATION_NAME: 'Empty Organization',
  QALEA_ORGANIZATION_NAME: 'Qalea',
  ACME_ORGANIZATION_NAME: 'Acme Corporation',
  PAYFLOW_ORGANIZATION_NAME: 'Payflow',
  AUTOHIDE_DURATION_SNACKBAR: 6000,
  HOME_PAGE,
  MAINTENANCE_PAGES: [] as string[],
  MAINTENANCE_ORGANIZATIONS: [] as string[],
  MAIL_PROVIDERS_PRIORITY: ['sendgrid', 'mailtrap'] as IMailProvider[],
  PHISHING: {
    DOCUMENTATION_URLS: {
      MICROSOFT:
        'https://qalea-documentation.notion.site/' +
        'Setting-your-Mail-Service-Microsoft-365-Guide-1832bcea0d71805ebd34f505c2ff8e2e',
      GMAIL:
        'https://qalea-documentation.notion.site/' +
        'Setting-your-Mail-Service-Google-Workspace-1832bcea0d718069b493d5f0d45a20a6',
    },
    EXERCISES_PREFERENCES_URL: 'https://1ta5z5kzl84.typeform.com/to/HpHniZny',
  },
  TRAINING: {
    VIDEO_URL: 'https://youtube.com/your-training-video',
    DOCUMENTATION_URLS: {
      GUIDE: 'https://qalea-documentation.notion.site/',
      // add other documentation URLs
    },
  },
  PASSWORD_MANAGER: {
    DOCUMENTATION_URLS: {
      GUIDE: 'https://qalea.featurebase.app/en/help/articles/4025040-password-manager-user-handbook',
      EXTENSION: 'https://qalea.featurebase.app/en/help/collections/1090261-password-manager',
    },
    EXTENSION_URL: 'static/password-manager/qalea-pass-extension-chrome.zip',
  },

  AGENT: {
    DOCUMENTATION_URLS: {
      INSTALL: 'https://qalea.featurebase.app/en/help/collections/8306542-monitoring',
    },
  },
  MDM: {
    ENROLL_URL: 'https://mdm-gcp.qa-secure.com/enroll',
    DOCUMENTATION_URLS: {
      //@TODO: https://app.notion.com/p/MDM-Mobile-Create-a-wiki-to-help-users-install-it-3b32bcea0d718036a6e8dd63ce4d9405?source=copy_link
      MOBILE_ENROLLMENT: 'https://qalea.featurebase.app/en/help',
    },
  },

  AVAILABLE_STANDARDS_FOR_CONSULTANT: ['ISO 27001', 'ENS', 'ISO 9001'],
  MAIL_TO_HELP: 'mailto:help@qalea.ai', // TODO: Change this to a valid email,{MAIL_TO_HELP}
  EMAIL_ADDRESSES: {
    CUSTOMER_SUPPORT: 'support-qalea@qalea.ai',
    ENGINEERING: 'engineering@qalea.ai',
    TRUST_CENTER: 'trust-center-requests@qalea.ai',
    HELP: 'help@qalea.ai',
  },
  BASE_URL: {
    local: 'http://localhost:3000',
    test: 'http://localhost:3001',
    development: 'https://dev.qalea.ai',
    production: 'https://app.qalea.ai',
  },
  AUTH: {
    HASH_OPTIONS: {
      memoryCost: 19456,
      timeCost: 2,
      outputLen: 32,
      parallelism: 1,
    },
    LOGIN_TOKEN_EXPIRATION_MS: 30 * 60 * 1000, // 30 minutes
  },
  MOCKED_PAGES: ['/crisis-manager', '/approved-software'],
  DEFAULT_USER_ROLE: USER_ROLES.EDITOR,
  EXCLUDED_PAGES: [
    CONTEXT_DOCUMENTS_ROUTE,
    '/employee-center',
    '/backoffice/organizations',
    '/backoffice/compliance-data',
    SUPPLIER_QUESTIONNAIRES.BACKOFFICE_PATH,
    '/backoffice/customer-success',
    '/backoffice/scans',
    '/backoffice/standard-editor',
    PUBLIC_API.BACKOFFICE_PAGE_URL,
    '/connectors',
    '/approved-software', // @TODO: Review and open/create the specific capability
    '/compliance/new-tasks', // @TODO: Review
    '/compliance/new-non-conformities',
    '/integrations/microsoft',
    '/siem', // @TODO: Review and put this under monitoring once all development is settled
    '/edr', // @TODO: Review and put this under monitoring once all development is settled
    '/new-home', // @TODO: Design preview, remove once it replaces the home page
  ],
  TRUST_CENTER_HOST: 'trust.qalea.ai',

  CONNECTORS: {
    SUCCESS: 'https://app.qalea.ai/connection-success',
    FAILED: 'https://app.qalea.ai/connection-failed',
  },
}

export default S
